<template>
    <div class="page">
        <v-container :class="{'pa-0': phoneOnly}">
            <!-- <h1 class="mb-2">classes</h1>
            <p>Hello, welcome to Ulum Al-Azhar Portal</p> -->
            
            <v-card :flat="phoneOnly" class="px-2 bordered" :class="{'rounded': pcOnly}" :style="{'border-radius': phoneOnly ? '0' : ''}">
                <v-card-title class="d-flex justify-space-between">
                    <div>Time Table</div>
                    <div class="px-3">
                        <v-btn color="primary" depressed @click="createDialog=true">
                            <v-icon left>mdi-plus-circle</v-icon>
                            <span>Add</span>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text v-if="!loading" :class="{'px-0': phoneOnly}">
                    <v-simple-table v-if="timeTableItems && timeTableItems.length" class="e-data-table">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        
                                    </th>
                                    <th class="text-left">
                                        Day
                                    </th>
                                    <th class="text-left">
                                        From
                                    </th>
                                    <th class="text-left">
                                        To
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="time in timeTableItems" :key="time.id">
                                    <td>
                                        <v-btn icon color="error" @click="timeToDelete = time; deleteDialog = true;">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                    <td>
                                        <span class="font-weight-semibold">{{ getDay(time.day) }}</span>
                                    </td>
                                    <td>
                                        <span class="font-weight-semibold ">{{ timeReadable(time.start_time) }}</span>
                                    </td>
                                    <td>
                                        <span class="font-weight-semibold ">{{ timeReadable(time.end_time) }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <div v-else-if="!loading">
                        <v-alert color="muted" text>
                            -------
                        </v-alert>
                    </div>
                </v-card-text>
            </v-card>

            <action-dialog v-model="createDialog" :as-form-data="true" action="post" url="/time-table" success-msg="Time added successfully" title="Add time" button-text="Create" max-width="400" :data="createForm" @reset="resetCreateForm" @sync="addItem">
                <v-select v-model="createForm.day" :menu-props="{offsetY: true}" filled hide-details class="mb-5" label="Day" :items="daysItems"></v-select>
                <time-input v-model="createForm.start_time" :outlined="false" filled half-format label="From" placeholder="From" class="mb-5" />
                <time-input v-model="createForm.end_time" :min="createForm.start_time || ''" :outlined="false" filled half-format label="To" placeholder="To" class="mb-5" />
            </action-dialog>

            
            <action-dialog v-model="deleteDialog" action="delete" :url="`/time-table/${timeToDelete ? timeToDelete.id : ''}`" max-width="400" title="Delete Time" button-text="Delete" button-color="error" @sync="deleteItem">
                <div>
                    Are you sure you want to delete this time from your time table?
                </div>
            </action-dialog>
        </v-container>
        
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import TimeInput from '@/components/custom/time-input'


export default {
    name: "time-table",
    components: {
        TimeInput        
    },
    data(){
        return {
            searchQuery: '',
            loading: false,
            timeTableItems: null,

            editDialog: false,
            editedItem: {

            },
            createDialog: false,
            createForm: {
                day: '',
                start_time: '',
                end_time: '',
            },
            deleteDialog: null,
            timeToDelete: null,

            daysItems: [
                {text: 'Saturday', value: 6},
                {text: 'Sunday', value: 0},
                {text: 'Monday', value: 1},
                {text: 'Tuesday', value: 2},
                {text: 'Wednesday', value: 3},
                {text: 'Thursday', value: 4},
                {text: 'Friday', value: 5},
            ]
        }
    },
    computed: {
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('fastGetAction', {url: '/time-table'}).then((response)=>{
                    this.timeTableItems = response.data.data;
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        getDay(day){
            const daysItems = this.daysItems;

            const item = daysItems.find(d=>d.value === parseInt(day));
            return item ? item.text : '';
        },
        resetCreateForm(){
            this.createForm = {
                day: '',
                start_time: '',
                end_time: '',
            };
        },
        openEditDialog(time){
            Object.assign(this.editedItem, time);
            this.editDialog = true;
        },
        resetEditForm(){
            Object.assign(this.editedItem, {
                id: null,
                name: '',
                
            });
        },
        addItem(item){
            this.timeTableItems.push(item);
        },
        syncItem(newItem){
            this.timeTableItems = this.timeTableItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(response){
            const id = response.id || this.timeToDelete.id;
            this.timeTableItems = this.timeTableItems.filter(time=>time.id !== id);
        },
    },
    mounted(){
        this.loadData();
    }
};
</script>
